import styled from '@emotion/styled';
import { CardActionArea } from '@mui/material';

export const useScheduleCardStyles = () => {
  return {
    timeSpan: { fontSize: '0.875rem' },
  };
};

export const StyledCard = styled(CardActionArea)({
  display: 'flex',
  alignItems: 'center',
  padding: '0.4375rem 0.875rem',
  borderRadius: '0.5rem',
  marginTop: '0.75rem',
});

export const StyledStatus = styled;
